/**
 * Returns the active tenant for the application.
 * Prioritizes Storybook tenant if running in Storybook, otherwise uses environment variable.
 *
 * @returns {string} Active tenant name
 */
export const getActiveTenant = () => {
  if (typeof window !== 'undefined' && window.__STORYBOOK_TENANT) {
    return window.__STORYBOOK_TENANT
  }
  return process.env.REACT_APP_TENANT
}
